import React from 'react';
import { getMediaPath } from 'utils/environment';

const Img = (props) => {
	const { src, alt, ...rest } = props;
	return <img src={ getMediaPath(src) } alt={alt} {...rest} />
}

export default Img;


// WEBPACK FOOTER //
// ./src/components/common/Img.jsx